import React from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import { updateBeforeCallsFormForWA } from '../../../../actions/organisation.js';
import 'react-quill/dist/quill.snow.css';

export default function CenterPanelReadOnly(props) {
  return (
    <div>
      <div className="ui form">
        <label id="before-call-important-info-caption" className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.OrgUnitDefaultBeforeCallsForWA.TitlePartOneReadOnly}
          <div className="inline-flex">{APP.LANGUAGE.OrgUnitDefaultBeforeCallsForWA.TitlePartTwo}</div>
        </label>
        <div>
          <ReactQuill
            readOnly="true"
            modules={CenterPanelReadOnly.modules}
            value={props.beforeCallsFormForWA.importantInfo.value || ''}
            placeholder={APP.LANGUAGE.OrgUnitDefaultBeforeCallsForWA.Title}
            className="rich-text-editor"
          />
        </div>
      </div>
    </div>
  );
}

CenterPanelReadOnly.modules = {
  toolbar: false, // Hide the toolbar
};
